var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelIcon20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7942_174940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7591 10.0015L19.6377 2.12173C20.1208 1.63853 20.1208 0.857984 19.6377 0.374787C19.1545 -0.108409 18.3741 -0.108409 17.891 0.374787L10.0124 8.25461L2.1214 0.362397C1.63828 -0.120799 0.845463 -0.120799 0.362341 0.362397C-0.12078 0.845594 -0.12078 1.63853 0.362341 2.12173L8.24094 10.0015L0.362341 17.8938C-0.12078 18.377 -0.12078 19.1575 0.362341 19.6407C0.610096 19.8885 0.919789 20 1.24187 20C1.56395 20 1.87365 19.8761 2.1214 19.6407L10 11.7609L17.8786 19.6407C18.1264 19.8885 18.436 20 18.7581 20C19.0802 20 19.3899 19.8761 19.6377 19.6407C20.1208 19.1575 20.1208 18.377 19.6377 17.8938L11.7591 10.0139V10.0015Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7942_174940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon20);
export default __webpack_public_path__ + "static/media/CancelIcon-20.7c5203f7b63dd49683467fec4377c19e.svg";
export { ForwardRef as ReactComponent };